import React, { useState, useEffect } from "react";
import {
  BiAddToQueue,
  BiLink,
  BiListCheck,
  BiSave,
  BiTaskX,
  BiTrash,
  BiTrashAlt,
  BiX,
} from "react-icons/bi";
import {
  Modal,
  ModalHeader,
  Row,
  Col,
  Button,
  ModalBody,
  Input,
  Label,
  Alert,
  Table,
  Popover,
  PopoverHeader,
  PopoverBody,
  UncontrolledTooltip,
} from "reactstrap";
import { validateSlackUrl } from "../../../utils/constants";
import { toastContainer } from "../../../utils/toast";
import "./enterprise-setting.css";
import moment from "moment";
import Tooltip from "../../../components/UI/TooltipIcon/TooptipIcon";
import OoPopover from "../../../components/UI/Popover/OoPopover";
import slackInfo from '../../../assets/add-slack-url.png';
import azureInfo from '../../../assets/add-azure-info.png'

export default function AllowedWorkspacesComp({
  open,
  onClose,
  allowedWorkspaces,
  addApi,
  removeWorkspace,
  popupType,
  isEnterprise
}) {
  const [selectedTab, setSelectedTab] = useState(open || 2);
  const [workspaceAddObject, setWorkspaceAddObject] = useState({
    workspaceId: "",
    workspaceName: "",
    enterpriseId:""
  });
  const [errors, setErrors] = useState({
    workspaceName: "",
    workspaceId: "",
    existing: "",
    enterpriseId:""
  });

  const WORKSPACE_VAR = isEnterprise ? "Enterprise": "Workspace";

  const [workspaces, setWorkspaces] = useState([]);
  const [searchInput, setSearchInput] = useState("");

  const extractClientAndAlphanumeric = (url) => {
    // Use a regular expression to find "client" and the first alphanumeric string after it
    const match = url && url.match(/client\/([A-Za-z0-9]+)/i);

    if (match) {
      // If a match is found, extract everything before and including "client" and the matched alphanumeric string
      return url.slice(0, match.index + match[0].length);
    } else {
      // If no match is found, return the original string or handle the case as needed
      return url;
    }
  };

  useEffect(() => {
    setWorkspaces([...allowedWorkspaces]);
    setSearchInput("");
  }, [allowedWorkspaces]);

  const handleChange = (e, key) => {
    const obj = { ...workspaceAddObject };
      obj[key] = e.target.value;
    setWorkspaceAddObject({ ...obj });
  };

  const validateError = () => {
    if (popupType === "Slack") {
      if (workspaceAddObject.workspaceId) {
        if (!validateSlackUrl(workspaceAddObject.workspaceId)) {
          setErrors({
            ...errors,
            workspaceId: "Invalid Workspace Url",
          });
          return true;
        }
      } 
    
      else if (workspaceAddObject.enterpriseId) {
        if (workspaceAddObject.enterpriseId.length==0) {
          setErrors({
            ...errors,
            workspaceId: "Invalid Enterprise Url",
          });
          return true;
        }
      } 
      
      else {
        
        setErrors({
          ...errors,
          workspaceId: `Please Add ${WORKSPACE_VAR} Url`,
        });
        return true;
      }

      if (!workspaceAddObject.workspaceName) {
        setErrors({
          ...errors,
          workspaceName: "Please Enter Workspace Name",
        });
        return true;
      }
    } else {
      if (!workspaceAddObject.workspaceId) {
        setErrors({
          ...errors,
          workspaceId: "Please Enter Tenant Id",
        });
        return true;
      }

      if (!workspaceAddObject.workspaceName) {
        setErrors({
          ...errors,
          workspaceName: `Please Enter ${WORKSPACE_VAR} Name`,
        });
        return true;
      }
    }
  };

  const handleSave = () => {
    const isError = validateError();

    if (!isError) {
      const existing = allowedWorkspaces.find(
        (x) =>
          x.workspaceId === workspaceAddObject.workspaceId ||
          x.workspaceName === workspaceAddObject.workspaceName
      );

      if (existing) {
        setErrors({
          ...errors,
          existing: "Data already exists , Please enter new",
        });
      } else {
        setErrors({
          workspaceName: "",
          workspaceId: "",
          existing: "",
        });
        addApi(workspaceAddObject)
          .then((res) => {
            toastContainer(res, "success");
            setWorkspaceAddObject({
              workspaceId: "",
              workspaceName: "",
            });
          })
          .catch((err) => {
            toastContainer(err, "error");
          });
      }
    }
  };
  return (
    <div>
      <Modal isOpen={open == 1 || open == 2}>
        <ModalHeader className={"edit-modal-actions"}>
          <Row>
            <Col xs={10}>
              <h5 className="ml-3 mt-2">
                {popupType} {WORKSPACE_VAR}{" "}
              </h5>
            </Col>
            <Col xs={2} className="text-right">
              <div className="pt-1 px-2">
                <Button className="p-1 mx-1" color="light">
                  <BiX size={"26px"} onClick={onClose} />
                </Button>
              </div>
            </Col>
          </Row>
        </ModalHeader>
        <ModalBody>
          <div className={`col-md-12 p-0`}>
            {selectedTab === 1 ? (
              <div className="mx-2">
                <span
                  className="wp-link-text my-2"
                  onClick={() => {
                    setSelectedTab(2);
                  }}
                >
                  View linked {popupType} {WORKSPACE_VAR}{" "}
                  <BiLink size={"18px"} />{" "}
                </span>
                <h4 className="mt-4">
                  Link a {popupType} {WORKSPACE_VAR}
                </h4>
                <div></div>
                <div className="mt-4">
                  <Label className="wp-add-popup-input-labels">
                    {popupType === "Slack"
                      ? `Slack ${WORKSPACE_VAR} Url`
                      : "Teams Tenant Id"}
                    {popupType === "Slack" ? (
                      <OoPopover
                        target={"tooltip_where_slack_url"}
                        placement="bottom"
                        css_class="sltm-css-es"
                        headerText="Where is my slack url?"
                        bodyText={
                          <span>
                            {/* Open your slack web application in (any) browser and copy the url. If you are using the Slack desktop application (see image below), click on the workspace name on the top left, copy the Slack url into the browser to be taken to the Slack web application. Then, like in the first scenario, copy the url and paste it. */}
                            Open your slack web application or slack desktop application (see image below), click on the workspace name on the top left and copy the Slack url (eg: acmeinc.slack.com) and paste it.
                            <img className="es-img-po" src={slackInfo}/>
                            
                          </span>}
                      />
                    ) : (
                      <OoPopover
                        target={"tooltip_where_tenant_id"}
                        placement="bottom"
                        css_class="sltm-css-es"
                        headerText="Where is my tenant id?"
                        bodyText={
                          <span>
                            In the Azure portal, click Azure Active Directory.
                            Then in the left hand navigation menu click
                            Properties. The tenant ID is shown in the main
                            screen
                            <br/>
                            <a
                              href="https://learn.microsoft.com/en-us/azure/active-directory/fundamentals/how-to-find-tenant"
                              target="_blank"
                            >
                              Click here{" "}
                            </a>{" "}
                            to see more.

                            <img className="es-img-po" src={azureInfo}/>
                          </span>
                        }
                      />
                    )}
                  </Label>
                  <Input
                    value={isEnterprise?workspaceAddObject.enterpriseId:workspaceAddObject.workspaceId}
                    onChange={(e) => {
                      if(isEnterprise){
                        handleChange(e, "enterpriseId")
                      }else{
                        handleChange(e, "workspaceId")
                      }
                    } }
                    placeholder={
                      popupType === "Slack"
                        ? `Enter Slack ${WORKSPACE_VAR} Url eg - ouroffice.slack.com`
                        : "Enter Teams Tenant Id"
                    }
                  />

                  <div className={"text-danger"}>{errors.workspaceId}</div>
                </div>
                <div className="mt-4">
                  <Label className="wp-add-popup-input-labels">
                    {popupType === "Slack"
                      ? `Slack ${WORKSPACE_VAR} Name`
                      : "Teams Tenant Name"}
                  </Label>
                  <Input
                    value={workspaceAddObject.workspaceName}
                    onChange={(e) => handleChange(e, "workspaceName")}
                    placeholder={`Enter ${WORKSPACE_VAR} Name`}
                  />
                  <div className={"text-danger"}>{errors.workspaceName}</div>
                </div>

                <div className={"text-danger mt-3"}>{errors.existing}</div>
                <div className="wp-add-action-buttons-div">
                  <Button
                    color="secondary"
                    className="wp_add_action_clear_btn"
                    onClick={() => {
                      setWorkspaceAddObject({
                        workspaceId: "",
                        workspaceName: "",
                      });
                    }}
                  >
                    Clear <BiTaskX className="ml-2" />
                  </Button>
                  <Button
                    color="primary"
                    className="wp_add_action_save_btn"
                    onClick={() => {
                      handleSave();
                    }}
                  >
                    Create Link <BiSave className="ml-2" />{" "}
                  </Button>
                </div>
              </div>
            ) : (
              <div className="m-1">
                <div className="">
                  <div>
                    Find {popupType.toLowerCase()} accounts/workspaces below.{" "}
                    <span
                      className="cursor-pointer wp-link-text"
                      onClick={() => {
                        setSelectedTab(1);
                      }}
                    >
                      Click here to link another {popupType.toLowerCase()}
                    </span>
                  </div>

                  <div className="my-3">
                    <Input
                      className="singleTaskItemSearch"
                      placeholder="Search by name"
                      value={searchInput}
                      onChange={(e) => {
                        const val = e.target.value;
                        setSearchInput(val);

                        if (val) {
                          const filteredWps = allowedWorkspaces.filter((x) =>
                            x.workspaceName
                              .toLowerCase()
                              .includes(val.toLowerCase())
                          );

                          setWorkspaces([...filteredWps]);
                        } else {
                          setWorkspaces([...allowedWorkspaces]);
                        }
                      }}
                    />
                  </div>
                  <Table responsive hover className="taskToolkitTable">
                    <thead>
                      <tr>
                        <th>Account/Workspace</th>
                        <th>Workspace Name</th>

                        <th>Linked On</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {workspaces.map((e, idx) => {
                        return (
                          <React.Fragment key={e.workspaceName}>
                            <tr
                              className="linkedToolTable"
                              key={e.workspaceName}
                            >
                              <td>{e.workspaceId || e.enterpriseId}</td>

                              <td>{e.workspaceName}</td>

                              <td>
                                {moment(e.createdOn).format("MMM Do, YYYY")}
                              </td>

                              <td>
                                {" "}
                                <BiTrash
                                  className="cursor-pointer"
                                  size={"18px"}
                                  onClick={() => removeWorkspace(e)}
                                />{" "}
                              </td>
                            </tr>
                          </React.Fragment>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              </div>
            )}
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
}
